module.exports = "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif"